"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = exports.Intro = exports.ImageWrapper = exports.Category = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('a')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'block',
  textAlign: 'center',
  textDecoration: 'none',
  maxWidth: _constants.ARTICLE_BOX_MOBILE_WIDTH,
  '&:active, &:focus, &:hover': {
    color: theme.palette.text.secondary,
    WebkitTapHighlightColor: 'transparent'
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH
  }
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: theme.spacing(1),
  display: 'flex',
  height: 170,
  margin: theme.spacing(0, 'auto', 3, 'auto'),
  overflow: 'hidden',
  position: 'relative',
  maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH,
  img: {
    height: '100%',
    left: 0,
    objectFit: 'cover',
    objectPosition: '50% 50%',
    position: 'absolute',
    top: 0,
    width: '100%'
  }
}));
const Category = exports.Category = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase'
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  margin: theme.spacing(0, 0, 1, 0),
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.h6.fontSize
  }
}));
const Intro = exports.Intro = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  margin: theme.spacing(0, 0, 2, 0),
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
}));
